import { render, staticRenderFns } from "./UpdateChildPresenceTemplateDrawer.vue?vue&type=template&id=8b27b84a&scoped=true&"
import script from "./UpdateChildPresenceTemplateDrawer.vue?vue&type=script&lang=js&"
export * from "./UpdateChildPresenceTemplateDrawer.vue?vue&type=script&lang=js&"
import style0 from "./UpdateChildPresenceTemplateDrawer.vue?vue&type=style&index=0&id=8b27b84a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b27b84a",
  null
  
)

export default component.exports